// eslint-disable-next-line no-restricted-imports
import { mergeWith } from 'lodash-es';

import type { DeepPartial } from '../types/utility-types';

import type { MergedThemeTypes } from './types';

export { spacing } from './shared/primitives';
export { registerTheme, registeredThemes, mergeThemes, overrideTheme } from './registry';

function isFunction(value: unknown): value is Function {
  return typeof value === 'function';
}

type ThemeUtil = DeepPartial<MergedThemeTypes> | (Record<string, any> & {});

export function extendTheme<T extends ThemeUtil>(
  defaultTheme: T,
  overrides: T,
  ...restOverrides: T[]
) {
  function customizer(source: unknown, override: unknown) {
    if (isFunction(source)) {
      return (...args: unknown[]) => {
        const sourceValue = source(...args);
        const overrideValue = isFunction(override) ? override(...args) : override;
        return mergeWith({}, sourceValue, overrideValue, customizer);
      };
    }
    return undefined;
  }

  const finalOverrides = [overrides, ...restOverrides].reduce(
    (prevValue, currentValue) => mergeWith({}, prevValue, currentValue, customizer),
    defaultTheme
  );

  return finalOverrides as T & MergedThemeTypes;
}
